import { render } from "./CircularLifecycle.vue?vue&type=template&id=499620be&scoped=true"
import script from "./CircularLifecycle.vue?vue&type=script&lang=js"
export * from "./CircularLifecycle.vue?vue&type=script&lang=js"

import "./CircularLifecycle.vue?vue&type=style&index=0&id=499620be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499620be"]])

export default __exports__